import React from 'react';

const Tickets = () => <div>tickets</div>;

export default Tickets;
